import { render } from "./ManualAdd.vue?vue&type=template&id=4d6d7191&scoped=true"
import script from "./ManualAdd.vue?vue&type=script&lang=js"
export * from "./ManualAdd.vue?vue&type=script&lang=js"

import "./ManualAdd.vue?vue&type=style&index=0&id=4d6d7191&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6d7191"]])

export default __exports__